export const version = '1.33.0';
export const scrollDelay = 50;
export const scrollDuration = 700;
export const scrollOffset = -60;
export const scrollSettings = {
  smooth: true,
  delay: scrollDelay,
  duration: scrollDuration,
  offset: scrollOffset,
  isDynamic: true
};
export const reservationReasonTextMaxLength = 80;
export const DATE_FORMAT_SYSTEM = 'YYYY-MM-DD';
export const EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION = 15;
export const showAdditionalDiscussionCheckbox = false;
export const showEmailConfirmationField = false;
export const letUserModifyTimeSlotParams = false;
export const DEFAULT_START_TIME = 7;
export const GOOGLE_MAPS_ZOOM = 14;
// Public by design; must stay restricted to the Maps Embed API (free, unlimited) in GCP
export const GOOGLE_MAPS_EMBED_API_KEY = 'AIzaSyCZ0zpBj_jUUQharIrtlxwqkPuh_BGnBOU';
export const APP_UPDATE_COOKIE_NAME = 'APP-BUILD-TIMESTAMP';
export const APP_UPDATE_HEADER_NAME = 'app-update';
export const APP_UPDATE_EXPIRE_TIME = 'Thu, 01 Jan 1970 00:00:01 GMT';
export const APP_TIMESTAMP = new Date().getTime();



// WEBPACK FOOTER //
// ./src/util/constants.js